<template>
  <!-- begin:: Aside -->
  <div class="brand flex-column-auto row mt-7 justify-content-end" id="kt_brand" ref="kt_brand">
    <div class="brand-logo col-6 d-flex justify-content-center">
      <router-link to="/dashboard">
        <v-img contain width="45px" src="@/assets/img/logo-dashboard.png" alt="Logo" />
      </router-link>
    </div>
    <div class="brand-tools col-3" v-if="allowMinimize">
      <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle" ref="kt_aside_toggle">
        <span class="svg-icon svg-icon svg-icon-xl">
          <inline-svg
            class="svg-icon"
            src="media/svg/icons/Navigation/Angle-double-right.svg"
          />
        </span>
      </button>
    </div>
    <div class="col-12 m-0 mb-4 p-0 text-center logo-sub">شبکه پرداخت آنلاین </div>
    <div class="col-12 solid-border"></div>
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss" scoped>
.aside-toggle {
  outline: none;
}
.solid-border {
  border-top: 1px solid rgba(75, 74, 96, 0.08);
}
.logo-sub{
  color: #4B4A60;
  font-family: Estedad;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}
</style>

<script>
import { mapGetters } from "vuex";
import objectPath from "object-path";
import KTLayoutBrand from "@/assets/js/layout/base/brand.js";
import KTLayoutAsideToggle from "@/assets/js/layout/base/aside-toggle.js";

export default {
  name: "KTBrand",
  mounted() {
    // Init Brand Panel For Logo
    KTLayoutBrand.init(this.$refs["kt_brand"]);

    // Init Aside Menu Toggle
    KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle"]);
  },
  methods: {
    siteLogo() {
      const menuAsideLeftSkin = this.layoutConfig("brand.self.theme");
      // set brand logo
      const logoObject = this.layoutConfig("self.logo");

      let logo;
      if (typeof logoObject === "string") {
        logo = logoObject;
      }
      if (typeof logoObject === "object") {
        logo = objectPath.get(logoObject, menuAsideLeftSkin + "");
      }
      if (typeof logo === "undefined") {
        const logos = this.layoutConfig("self.logo");
        logo = logos[Object.keys(logos)[0]];
      }
      return process.env.BASE_URL + logo;
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    allowMinimize() {
      return !!this.layoutConfig("aside.self.minimize.toggle");
    }
  }
};
</script>
